<div [formGroup]="f">
    <div class="expandCollapseContainer mb-1" [ngClass]="!enableFilter ? 'inputDisabled' : 'inputEnabled'">
        <button class="expandCollapseHeader filterButton mb-1" (click)="onDisplaySeriesFilter()">
            <strong>{{ 'series' | translate | async }}</strong>
            <ng-container *ngIf="displaySeriesFilter; else expandIcon">
                <svg class="ontario-icon expandCollapseIcon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24"
                preserveAspectRatio="xMidYMid meet">
                <use href="#ontario-icon-collapse"></use>
            </svg>
            </ng-container>
            <ng-template #expandIcon>
                <svg class="ontario-icon expandCollapseIcon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24"
                preserveAspectRatio="xMidYMid meet">
                <use href="#ontario-icon-expand"></use>
            </svg>
            </ng-template>
        </button>
    
        <div *ngIf="enableFilter && displaySeriesFilter">
            <div class="filterList pb-1">
                <ng-container *ngIf="(lang$ | async) === 'en' else frenchSeries">
                    {{ this.series.value && (this.series.value)[0] ? (this.series.value)[0]._source.name_en : ''}}
                </ng-container>
                <ng-template #frenchSeries>
                    {{ this.series.value && (this.series.value)[0] ? (this.series.value)[0]._source.name_fr : ''}}
                </ng-template>
    
                <span *ngIf="this.series.value.length > 1">
                    (+{{ this.series.value.length - 1 }}
                    {{ this.series.value.length === 2 ? 'other' : 'others' }})
                </span>
            </div>
    
            <mat-form-field appearance="outline" class="flex-child" color="accent">
                <mat-label>
                    {{ 'series' | translate | async }}
                </mat-label>
                <input matInput type="text" formControlName="tempSeries" [matAutocomplete]="auto">

                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith" showPanel="true"
                    (optionsScroll)="onScroll()">
                    <div *ngIf="tempSeries.value == '' || tempSeries.value == undefined" class="filter-item">
                        <!-- Added for accessibility - mat-option is required but if selected breaks the virtual drop-down -->
                        <mat-option (onSelectionChange)="toggleSelectAll($event)">
                            <mat-checkbox role="checkbox" class="customCheckbox" [checked]="updateAllSelected()" (change)="toggleSelectAll($event)"
                            (click)="$event.stopPropagation()">
                            {{ 'select.all' | translate | async }}
                        </mat-checkbox>
                        </mat-option>
                        
                    </div>
                    <div *ngFor="let item of filteredSeries$ | async" class="filter-item">
                        <!-- Added for accessibility - mat-option is required but if selected breaks the virtual drop-down -->
                        <mat-option (onSelectionChange)="toggleSelection(item, $event)">
                            <mat-checkbox role="checkbox" class="customCheckbox" [checked]="isSeriesChecked(item)"
                                (change)="toggleSelection(item, $event)" (click)="$event.stopPropagation()">
                                <ng-container *ngIf="(lang$ | async) === 'en' else frenchSeries">
                                    {{ item._source.name_en }}
                                </ng-container>
                                <ng-template #frenchSeries>
                                    {{ item._source.name_fr }}
                                </ng-template>
                            </mat-checkbox>
                        </mat-option>
                    </div>
                </mat-autocomplete>
            </mat-form-field>
            
        </div>
    </div>
</div>